export default __webpack_public_path__ + "static/01-03-reading-glossary-tool-176d3ec2aa57ff564ffb678a21954196.mp4";